// Labels dependentes do contexto do pedido (origin + flowType).
// Restaura comportamento original que existia na branch-matheus
// antes do refactor para feature-folders.

export function getPedidoOrigin(pedido) {
  return pedido?.origin || pedido?.reserva?.Pedido?.origin || null;
}

export function getReserva(pedido) {
  return pedido?.reserva || null;
}

export function getQrImageLabel(pedido) {
  const origin = getPedidoOrigin(pedido);
  const reserva = getReserva(pedido);

  if (origin === "ML" && reserva?.flowType === "DEVOLUCAO") {
    return "Imagem do QR Code";
  }
  if (origin === "OUTROS" && reserva?.flowType === "DEVOLUCAO") {
    return "Imagem do QR Code ou código de barras";
  }
  return "Imagem do código de barras";
}

export function getImageTypeLabel(pedido, type) {
  if (type === "PACKAGE_PHOTO") return "Foto do pacote";
  if (type === "LABEL_PHOTO") return "Foto da etiqueta";
  if (type === "QR_IMAGE") return getQrImageLabel(pedido);
  return type;
}

export function getSenderSiteLabel(pedido) {
  return getPedidoOrigin(pedido) === "OUTROS"
    ? "Site do remetente / Loja"
    : "Site do remetente";
}

export function getTypedCodeLabel(pedido) {
  const origin = getPedidoOrigin(pedido);
  const reserva = getReserva(pedido);
  return origin === "CORREIOS" && reserva?.flowType === "DEVOLUCAO"
    ? "Código de 10 dígitos"
    : "Código digitado";
}
